import React from "react";
import Header from "../components/Header";
import Recommendations from "../components/Recommendations";


function RecommendationsPage() {
  return (
    <>
    <Header/>
    <Recommendations/>
    </>
  );
}

export default RecommendationsPage;
